// Internal Links Configuration for SEO
// This file defines related pages and generates contextual internal links

interface InternalLink {
  title: string;
  description: string;
  url: string;
  keywords?: string[];
  category?: 'service' | 'location' | 'tool' | 'blog' | 'main';
}

// Service Pages - Spanish
export const serviceLinksES: InternalLink[] = [
  {
    title: "Auditoría SEO Profesional",
    description: "Análisis completo de tu sitio web para identificar oportunidades de mejora y problemas técnicos que afectan tu posicionamiento.",
    url: "/servicios/seo-diagnostico",
    keywords: ["auditoría SEO", "análisis web", "SEO técnico"],
    category: 'service'
  },
  {
    title: "Estrategias SEO y SEM",
    description: "Estrategias integradas de posicionamiento orgánico y pago para maximizar tu visibilidad en buscadores.",
    url: "/servicios/seo-sem-estrategias",
    keywords: ["SEO", "SEM", "estrategia digital"],
    category: 'service'
  },
  {
    title: "Gestión de Google Ads",
    description: "Campañas de publicidad en Google optimizadas para el mercado hispano con medición orientada a negocio.",
    url: "/servicios/google-ads",
    keywords: ["Google Ads", "PPC", "publicidad digital"],
    category: 'service'
  },
  {
    title: "Posicionamiento en LLMs",
    description: "Optimiza tu contenido para aparecer en ChatGPT, Claude, Perplexity y otras inteligencias artificiales generativas.",
    url: "/servicios/posicionamiento-llm",
    keywords: ["LLM", "ChatGPT", "AI search", "IA generativa"],
    category: 'service'
  },
  {
    title: "Consultoría Amazon",
    description: "Estrategias especializadas para vendedores de Amazon: SEO interno, publicidad y optimización de listados.",
    url: "/servicios/amazon-consulting",
    keywords: ["Amazon", "marketplace", "ecommerce"],
    category: 'service'
  },
  {
    title: "Rebranding con SEO",
    description: "Cambio de marca digital con estrategia SEO integrada para no perder posicionamiento durante la transición.",
    url: "/servicios/rebranding-seo",
    keywords: ["rebranding", "migración SEO", "cambio de marca"],
    category: 'service'
  },
  {
    title: "Contenido para Conversión",
    description: "Creación de contenido optimizado orientado a generar conversiones y ventas, no solo tráfico.",
    url: "/servicios/contenido-conversion",
    keywords: ["contenido", "copywriting", "conversión"],
    category: 'service'
  }
];

// Service Pages - English
export const serviceLinksEN: InternalLink[] = [
  {
    title: "Professional SEO Audit",
    description: "Complete website analysis to identify improvement opportunities and technical issues affecting your rankings.",
    url: "/en/services/seo-audit",
    keywords: ["SEO audit", "website analysis", "technical SEO"],
    category: 'service'
  },
  {
    title: "SEO & SEM Strategies",
    description: "Integrated organic and paid positioning strategies to maximize your visibility in search engines.",
    url: "/en/services/seo-sem-strategies",
    keywords: ["SEO", "SEM", "digital strategy"],
    category: 'service'
  },
  {
    title: "Google Ads Management",
    description: "Google advertising campaigns optimized for the Hispanic market with business-oriented measurement.",
    url: "/en/services/google-ads",
    keywords: ["Google Ads", "PPC", "digital advertising"],
    category: 'service'
  },
  {
    title: "LLM Positioning",
    description: "Optimize your content to appear in ChatGPT, Claude, Perplexity and other generative AI search results.",
    url: "/en/services/llm-positioning",
    keywords: ["LLM", "ChatGPT", "AI search"],
    category: 'service'
  },
  {
    title: "Amazon Consulting",
    description: "Specialized strategies for Amazon sellers: internal SEO, advertising and listing optimization.",
    url: "/en/services/amazon-consulting",
    keywords: ["Amazon", "marketplace", "ecommerce"],
    category: 'service'
  },
  {
    title: "Rebranding with SEO",
    description: "Digital rebranding with integrated SEO strategy to maintain rankings during transition.",
    url: "/en/services/rebranding-seo",
    keywords: ["rebranding", "SEO migration", "brand change"],
    category: 'service'
  },
  {
    title: "Content for Conversion",
    description: "Optimized content creation focused on generating conversions and sales, not just traffic.",
    url: "/en/services/content-conversion",
    keywords: ["content", "copywriting", "conversion"],
    category: 'service'
  }
];

// Houston Metro Location Pages
export const houstonLocationLinks: InternalLink[] = [
  {
    title: "SEO Houston",
    description: "Servicios de SEO local para empresas en Houston. Domina las búsquedas locales y atrae más clientes.",
    url: "/seo-houston",
    keywords: ["SEO Houston", "SEO local Houston", "posicionamiento Houston"],
    category: 'location'
  },
  {
    title: "Google Ads Houston",
    description: "Campañas de Google Ads optimizadas para el mercado de Houston con resultados medibles.",
    url: "/google-ads-houston",
    keywords: ["Google Ads Houston", "PPC Houston", "publicidad Houston"],
    category: 'location'
  },
  {
    title: "SEO The Woodlands",
    description: "Agencia SEO especializada en The Woodlands. Auditorías, optimización y generación de leads.",
    url: "/seo-the-woodlands",
    keywords: ["SEO The Woodlands", "agencia SEO", "marketing The Woodlands"],
    category: 'location'
  },
  {
    title: "Google Ads The Woodlands",
    description: "Gestión de Google Ads para empresas en The Woodlands con medición orientada a negocio.",
    url: "/google-ads-the-woodlands",
    keywords: ["Google Ads The Woodlands", "PPC The Woodlands"],
    category: 'location'
  },
  {
    title: "SEO Spring",
    description: "Servicios de SEO para negocios en Spring, TX. Aumenta tu visibilidad local.",
    url: "/seo-spring",
    keywords: ["SEO Spring", "SEO local Spring TX"],
    category: 'location'
  },
  {
    title: "SEO Conroe",
    description: "Posicionamiento web para empresas en Conroe. SEO local que genera resultados.",
    url: "/seo-conroe",
    keywords: ["SEO Conroe", "marketing Conroe"],
    category: 'location'
  },
  {
    title: "SEO Katy",
    description: "Servicios de SEO especializado para negocios en Katy, TX.",
    url: "/seo-katy",
    keywords: ["SEO Katy", "SEO local Katy"],
    category: 'location'
  },
  {
    title: "SEO Sugar Land",
    description: "Optimización de motores de búsqueda para empresas en Sugar Land.",
    url: "/seo-sugar-land",
    keywords: ["SEO Sugar Land", "marketing Sugar Land"],
    category: 'location'
  }
];

// Florida Location Pages
export const floridaLocationLinks: InternalLink[] = [
  {
    title: "SEO Miami",
    description: "Servicios profesionales de SEO para empresas en Miami. Domina el mercado local.",
    url: "/seo-miami",
    keywords: ["SEO Miami", "SEO local Miami", "marketing Miami"],
    category: 'location'
  },
  {
    title: "Google Ads Miami",
    description: "Campañas de Google Ads optimizadas para el competitivo mercado de Miami.",
    url: "/google-ads-miami",
    keywords: ["Google Ads Miami", "PPC Miami"],
    category: 'location'
  },
  {
    title: "SEO Orlando",
    description: "Posicionamiento web para negocios en Orlando con estrategias locales efectivas.",
    url: "/seo-orlando",
    keywords: ["SEO Orlando", "marketing Orlando"],
    category: 'location'
  },
  {
    title: "Google Ads Orlando",
    description: "Gestión de campañas de Google Ads para empresas en Orlando, Florida.",
    url: "/google-ads-orlando",
    keywords: ["Google Ads Orlando", "publicidad Orlando"],
    category: 'location'
  }
];

// SEO Tools
export const toolLinksES: InternalLink[] = [
  {
    title: "SEO Mega Tool",
    description: "Herramienta completa de auditoría SEO con análisis técnico, on-page y competencia.",
    url: "/herramientas/seo-mega-tool",
    keywords: ["auditoría SEO", "herramienta SEO", "análisis web"],
    category: 'tool'
  },
  {
    title: "Generador de Meta Tags",
    description: "Crea meta títulos y descripciones optimizados para SEO automáticamente.",
    url: "/herramientas/generador-metatags",
    keywords: ["meta tags", "SEO on-page"],
    category: 'tool'
  },
  {
    title: "Analizador SEO Local GMB",
    description: "Analiza y optimiza tu Google Business Profile para mejorar tu visibilidad local.",
    url: "/herramientas/analizador-seo-local-gmb",
    keywords: ["SEO local", "Google Business", "GMB"],
    category: 'tool'
  },
  {
    title: "Contador de Palabras",
    description: "Analiza densidad de palabras clave y optimiza tu contenido para SEO.",
    url: "/herramientas/contador-palabras",
    keywords: ["densidad keywords", "análisis contenido"],
    category: 'tool'
  },
  {
    title: "Generador de Contenido IA",
    description: "Crea contenido optimizado para SEO usando inteligencia artificial.",
    url: "/herramientas/generador-contenido",
    keywords: ["IA contenido", "generador texto", "AI copywriting"],
    category: 'tool'
  }
];

// Main Pages
export const mainLinksES: InternalLink[] = [
  {
    title: "Sobre Luis ROC",
    description: "Conoce la trayectoria y experiencia de Luis ROC, consultor en SEO, Search Growth y marketing digital.",
    url: "/sobre-mi",
    keywords: ["consultor SEO", "experiencia", "trayectoria"],
    category: 'main'
  },
  {
    title: "Casos de Éxito",
    description: "Descubre cómo hemos ayudado a empresas hispanas a crecer con estrategias de SEO y marketing digital.",
    url: "/casos-de-exito",
    keywords: ["portfolio", "casos éxito", "resultados"],
    category: 'main'
  },
  {
    title: "Metodología",
    description: "Conoce nuestra metodología de trabajo y proceso de implementación de estrategias SEO.",
    url: "/metodologia",
    keywords: ["proceso", "metodología SEO"],
    category: 'main'
  },
  {
    title: "Reunión inicial gratuita de 30 minutos",
    description: "Agenda una reunión inicial gratuita de 30 minutos para revisar qué necesita tu empresa.",
    url: "/diagnostico-seo-gratis",
    keywords: ["reunión inicial gratuita", "consultoría SEO"],
    category: 'main'
  },
  {
    title: "Herramientas SEO",
    description: "Accede a herramientas profesionales de SEO completamente gratuitas.",
    url: "/herramientas-seo",
    keywords: ["herramientas gratuitas", "SEO tools"],
    category: 'main'
  },
  {
    title: "Contacto",
    description: "¿Listo para llevar tu negocio al siguiente nivel? Contáctanos para una consulta personalizada.",
    url: "/contacto",
    keywords: ["consulta", "agendar", "contactar"],
    category: 'main'
  }
];

// Blog Links
export const blogLinksES: InternalLink[] = [
  {
    title: "Blog de Marketing Digital",
    description: "Artículos sobre SEO, marketing digital, IA y estrategias para hacer crecer tu negocio online.",
    url: "/blog",
    keywords: ["blog", "artículos SEO", "marketing"],
    category: 'blog'
  },
  {
    title: "Implementar IA en Marketing Digital",
    description: "Guía completa sobre cómo integrar inteligencia artificial en tu estrategia de marketing digital.",
    url: "/blog/implementar-ia-marketing-digital",
    keywords: ["IA marketing", "inteligencia artificial", "automatización"],
    category: 'blog'
  }
];

// Helper Functions to Generate Related Links

export const getRelatedLinks = (
  currentUrl: string,
  language: 'es' | 'en' = 'es',
  maxLinks: number = 6
): InternalLink[] => {
  const allLinks = language === 'es' 
    ? [...serviceLinksES, ...houstonLocationLinks, ...floridaLocationLinks, ...toolLinksES, ...mainLinksES, ...blogLinksES]
    : [...serviceLinksEN, ...houstonLocationLinks, ...floridaLocationLinks, ...mainLinksES, ...blogLinksES];

  // Determine the category of current page
  const currentCategory = getCurrentCategory(currentUrl);
  
  // Filter out current page and prioritize same category
  const filtered = allLinks.filter(link => link.url !== currentUrl);
  
  // Prioritize links from same category
  const sameCategory = filtered.filter(link => link.category === currentCategory);
  const otherLinks = filtered.filter(link => link.category !== currentCategory);
  
  // Combine with same category first
  const combined = [...sameCategory.slice(0, 4), ...otherLinks];
  
  return combined.slice(0, maxLinks);
};

const getCurrentCategory = (url: string): string => {
  if (url.includes('/servicios') || url.includes('/services')) return 'service';
  if (url.includes('/seo-') || url.includes('/google-ads-')) return 'location';
  if (url.includes('/herramientas') || url.includes('/tools')) return 'tool';
  if (url.includes('/blog')) return 'blog';
  return 'main';
};

// Get links for specific location pages
export const getLocationRelatedLinks = (
  city: string,
  language: 'es' | 'en' = 'es'
): InternalLink[] => {
  const isHouston = ['houston', 'spring', 'conroe', 'katy', 'sugar-land', 'tomball', 'magnolia', 'memorial', 'the-woodlands'].includes(city.toLowerCase());
  
  const locationLinks = isHouston ? houstonLocationLinks : floridaLocationLinks;
  const serviceLinks = language === 'es' ? serviceLinksES : serviceLinksEN;
  
  // Filter out current city
  const otherLocations = locationLinks.filter(link => 
    !link.url.toLowerCase().includes(city.toLowerCase())
  ).slice(0, 3);
  
  // Add related services
  const relatedServices = serviceLinks.slice(0, 3);
  
  return [...otherLocations, ...relatedServices];
};

// Get links for service pages
export const getServiceRelatedLinks = (
  currentService: string,
  language: 'es' | 'en' = 'es'
): InternalLink[] => {
  const serviceLinks = language === 'es' ? serviceLinksES : serviceLinksEN;
  
  // Filter out current service
  const otherServices = serviceLinks.filter(link => 
    link.url !== currentService
  ).slice(0, 3);
  
  // Add main pages
  const mainPages = mainLinksES.filter(link => 
    ['/casos-de-exito', '/diagnostico-seo-gratis', '/metodologia'].includes(link.url)
  );
  
  // Add location pages
  const topLocations = houstonLocationLinks.slice(0, 2);
  
  return [...otherServices, ...mainPages, ...topLocations].slice(0, 6);
};

// Get links for tool pages
export const getToolRelatedLinks = (
  currentTool: string,
  language: 'es' | 'en' = 'es'
): InternalLink[] => {
  const toolLinks = toolLinksES;
  const serviceLinks = language === 'es' ? serviceLinksES : serviceLinksEN;
  
  // Filter out current tool
  const otherTools = toolLinks.filter(link => link.url !== currentTool).slice(0, 3);
  
  // Add related services
  const relatedServices = [
    serviceLinks.find(s => s.url.includes('seo-diagnostico') || s.url.includes('seo-audit')),
    serviceLinks.find(s => s.url.includes('posicionamiento-llm') || s.url.includes('llm-positioning')),
    serviceLinks.find(s => s.url.includes('contenido-conversion') || s.url.includes('content-conversion'))
  ].filter(Boolean) as InternalLink[];
  
  return [...otherTools, ...relatedServices].slice(0, 6);
};

export default {
  getRelatedLinks,
  getLocationRelatedLinks,
  getServiceRelatedLinks,
  getToolRelatedLinks,
  serviceLinksES,
  serviceLinksEN,
  houstonLocationLinks,
  floridaLocationLinks,
  toolLinksES,
  mainLinksES,
  blogLinksES
};